import { useMemo, useState } from "react";
import { PropertyCard } from "./PropertyCard";

function ShowcaseBody({ data, properties }) {
  if (!data) return <div className="text-slate-400 py-16 text-center" data-testid="rooms-loading">Loading availability…</div>;
  if (properties.length === 0) {
    return (
      <div className="bg-white border border-slate-200 rounded-xl p-12 text-center text-slate-500" data-testid="rooms-empty">
        All rooms are currently full — check back soon.
      </div>
    );
  }
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
      {properties.map((p) => <PropertyCard key={p.property_id} prop={p} />)}
    </div>
  );
}

export function RoomsShowcase({ data }) {
  const [filterProp, setFilterProp] = useState("all");
  const all = useMemo(() => data?.properties || [], [data]);
  const properties = useMemo(() => all
    .map((p) => ({ ...p, rooms: p.rooms.filter((r) => r.vacant) }))
    .filter((p) => p.rooms.length > 0 && (filterProp === "all" || p.name === filterProp)), [all, filterProp]);

  return (
    <section id="rooms" className="py-16 sm:py-24 bg-slate-50 border-y border-slate-200" data-testid="rooms-showcase">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-blue-600 font-semibold">Live inventory</div>
            <h2 className="font-hero text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 mt-2">Rooms we have right now</h2>
            <p className="text-sm sm:text-base text-slate-500 mt-3 max-w-xl">
              Only rooms that are vacant right now are listed — with live count, rent and deposit. Apply in a minute.
            </p>
          </div>
          <select value={filterProp} onChange={(e) => setFilterProp(e.target.value)} data-testid="filter-property"
                  className="border border-slate-300 bg-white px-4 py-2.5 rounded-lg text-sm font-medium">
            <option value="all">All properties</option>
            {all.map((p) => <option key={p.property_id} value={p.name}>{p.name}</option>)}
          </select>
        </div>
        <ShowcaseBody data={data} properties={properties} />
      </div>
    </section>
  );
}
